module.exports = __webpack_public_path__ + "static/media/GasIcon.2dee9b61.svg";